module.exports = __webpack_public_path__ + "img/EN.a6abbe48.svg";